 <!-- Content Header (Page header) -->
 <section class="content-header">
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-6">
        <h1>{{titulo}}</h1>
      </div>
      <div class="col-sm-6">
        <ol class="breadcrumb float-sm-right">
          <li class="breadcrumb-item"><a href="#">www.andreagt.com</a></li>
          <li *ngIf="titulo !=='Dashboard'" class="breadcrumb-item active"> {{titulo}} </li>
          <li *ngIf="titulo ==='Dashboard'" class="breadcrumb-item active">  </li>
        </ol>
      </div>
    </div>
  </div><!-- /.container-fluid -->
</section>